import CustomModal from "../CustomModal";

function DisableUserModal({
  isOpen,
  handleCloseModals,
  userProfile,
  handleDisableUser,
}) {
  // Don't render modal if no userProfile
  if (!userProfile) {
    return null;
  }

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={handleCloseModals}
      className="delete-modal"
    >
      <div className="inner-member">
        <img
          src={`${process.env.PUBLIC_URL}/images/disable-modal-img.png`}
          alt="Disable user icon"
        />
        <b>
          <p>
            Are you sure you want to disable user access for the selected
            user?
          </p>
        </b>

        <div className="details-container container">
          <div className="detail">
            <p>Name</p>
            <b>
              <p className="D">
                {userProfile.l_name} {userProfile.f_name}
              </p>
            </b>
          </div>
          <div className="detail">
            <p>Gym Number</p>
            <b>
              <p className="D">#{userProfile.id}</p>
            </b>
          </div>
          <div className="detail">
            <p>Access Status</p>
            <b>
              <p className="D">
                {userProfile.access_status === 1 ? "Enabled" : "Disabled"}
              </p>
            </b>
          </div>
        </div>

        <div className="warning">
          <img
            src={`${process.env.PUBLIC_URL}/images/info-circle.png`}
            alt="Information icon"
          />
          <p>
            Note that disabling user access will prevent the member from
            entering the gym premises and using any associated services.
          </p>
        </div>

        <div className="inner-member-btn">
          <button onClick={handleCloseModals}>Cancel</button>
          <button
            style={{ backgroundColor: "#DD9828", color: "#FAFAFA" }}
            onClick={handleDisableUser}
          >
            Disable access
          </button>
        </div>
      </div>
    </CustomModal>
  );
}

export default DisableUserModal;
